import React from 'react';
import './Entreprise.css';

function Entreprise() {
  return (
    <div className="entreprise-container">
      <h1 className="entreprise-title fade-in-up">Quietec : Présentation de l'Entreprise</h1>
      <div className="logo-wrapper">
        <img 
          src="/quietec_logo.png" 
          alt="Logo Quietec" 
          className="quietec-logo"
        />
      </div>
      {/* Aperçu rapide de l'entreprise */}
      <section className="entreprise-intro fade-in-up">
        <p>
          Quietec est une entreprise de dépannage informatique et de prestation
          de services informatiques. Basée à Avignon,
          elle compte actuellement <strong>7 personnes</strong> dans son effectif, moi inclus.
        </p>
        <p>
          L’entreprise travaille avec des professionnels tout comme des particuliers et propose notamment :
          <ul>
            <li>Des contrats de maintenance</li>
            <li>De la vente de matériel (on priorise le reconditionné pour offrir au client une option à coût réduit)</li>
            <li>Des interventions de dépannage réseau et matériel</li>
            <li>De la mise en place de réseau professionnels avec intranet et serveurs dédiés sur leur site</li>
          </ul>
        </p>
      </section>
      
      {/* Modalités de fonctionnement */}
      <section className="entreprise-fonctionnement fade-in-up">
        <h2>Organisation & Fonctionnement</h2>
        <p>
          Quietec fonctionne de manière très souple : plutôt que d’utiliser 
          un système de ticketing classique, l’équipe partage un <strong>agenda commun </strong> 
          où sont planifiées les interventions. Cela permet une grande réactivité 
          et une communication fluide entre collègues.
        </p>
      </section>
      
      {/* Mon rôle, Mon ressenti */}
      <section className="entreprise-experience fade-in-up">
        <h2>Mon Expérience au sein de Quietec</h2>
        <p>
          Depuis que j’ai rejoint Quietec, je vis littéralement ma meilleure vie
          professionnelle. L’équipe est <strong>très accueillante</strong> et met un
          point d’honneur à me former sur un large éventail de tâches :
        </p>
        <ul>
          <li>
            Accompagner un collègue chez un client pour installer du matériel 
            (caméras, serveurs, postes) ou dépanner un réseau.
          </li>
          <li>
            Réaliser des <strong>travaux pratiques</strong> :  
            par exemple, récupérer un ancien poste pour le transformer en serveur,
            diagnostiquer un poste défectueux, ou proposer des solutions de réparation.
          </li>
          <li>
            Apprendre en faisant des erreurs, dans un cadre bienveillant où 
            l’objectif est de <strong>ne plus les reproduire </strong>  
            une fois en situation réelle chez un client.
          </li>
        </ul>
        <p>
          J’ai réellement l’impression que mon responsable 
          et mes collègues <strong>misent sur ma progression</strong>, 
          m’offrant de nombreuses opportunités de toucher à différentes 
          technologies et de <strong>développer mes compétences </strong> 
          dans un contexte professionnel.
        </p>
      </section>
      
      {/* Lien vers le site web */}
      <section className="entreprise-site fade-in-up">
        <h2>En savoir plus</h2>
        <p>
          Pour plus d’informations sur les services de Quietec, rendez-vous sur
          leur site :&nbsp;
          <a 
            href="https://www.quietec.com" 
            target="_blank" 
            rel="noreferrer"
            className="entreprise-link"
          >
            www.quietec.com
          </a>
        </p>
      </section>
    </div>
  );
}

export default Entreprise;
